import { useStaticQuery, graphql } from "gatsby"
export const CategoriesListDataFR = () => {
  const data = useStaticQuery(
    graphql`
      query CategoriesListFR {
        wpgraphql {
          productCategories(where: {wpmlLanguage: "fr", orderby: TERM_ORDER, exclude: [314, 357, 358,359]} first: 99) {
            nodes {
              name
              uri
              parent {
                node {
                  id
                }
              }
              children(where: {orderby: TERM_ORDER}) {
                nodes {
                  name
                  uri
                  children(where: {orderby: TERM_ORDER}) {
                    nodes {
                      name
                      uri
                    }
                  }
                }
              }
            }
          }
        }
      }
    `
  )
  return data.wpgraphql.productCategories
}
